import { render, staticRenderFns } from "./rewardBridgeGameEdit.vue?vue&type=template&id=e79d7d5e&scoped=true&"
import script from "./rewardBridgeGameEdit.vue?vue&type=script&lang=js&"
export * from "./rewardBridgeGameEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e79d7d5e",
  null
  
)

export default component.exports